require('./style.css');
var tmpl = require('./main.ejs');
var Events = require('f.core.event');
var util = require('f.core.mobile.util');

var ua = navigator.userAgent,
    isIos = navigator.userAgent.match(/iphone|ipod/ig),
    isIpad = navigator.userAgent.match(/ipad/ig),
    isIphone = isIos || isIpad;

var Input = function (options) {
  this.desc = options.desc || '我要说两句';
  this.maxLength = options.maxLength || 200;
  this.data = {
    size: 18,
    color: '0Xffffff'
  };
  this.init();
};

Input.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

Input.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl({desc: this.desc, maxLength: this.maxLength});
  this.el = div.children[0];
  this.elInput = this.el.querySelector('.c-barrage__input');
  this.elBtn = this.el.querySelector('.c-barrage__send');
  this.elTalk = this.el.querySelector('.l-input');
  this.elPad = this.el.querySelector('.l-padding');
  console.log(this.elTalk);
};


Input.prototype.initEvent = function () {

  util.tap(this.el, function (e, elm) {
    this.hide();
  }, {
    scope: this
  });

  util.tap(this.elTalk, function (e, elm) {
    return false;
  }, {
    scope: this
  });

  util.on(this.elInput, 'blur', function (e, elm) {
    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
    if (isIphone) {
      $(this.elTalk).css('top', '0px');
      $(this.elPad).css('top', '3000px');
    }
    this.hide();
    this.trigger('blur');
  }, {
    scope: this
  });

  util.on(this.elInput, 'focus', function (e, elm) {
    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
    if (isIphone) {
      var h1 = 0;
      if (Math.abs(dge) != 90) {
        h1 = $('.l-head').height();
      }
      setTimeout(function () {
        $(this.el).css('opacity', 1);
        $(this.elPad).css('top', (h1 + $(this.elTalk).outerHeight()) + 'px');
        document.body.scrollTop = 0;
        $(this.elTalk).css('top', h1 + 'px');
      }.bind(this), 200);
    }
  }, {
    scope: this
  });

  util.tap(this.elInput, function (e, elm) {
    this.elInput.focus();
  }, {
    scope: this
  });

  util.on(this.elInput, 'input', function (e, elm) {
    // var count = this.maxLength - elm.value.length;
    // if (count > 0 && count < this.maxLength) {
    //   $(this.elBtn).removeClass('disable');
    // } else {
    //   $(this.elBtn).addClass('disable');
    // }

    var count = elm.value.length;
    if (count > 0) {
      $(this.elBtn).removeClass('disable');
    } else {
      $(this.elBtn).addClass('disable');
    }

    if (this.maxLength < count) {
      console.log(this.maxLength, count);
      elm.value = elm.value.slice(0, this.maxLength);
    }

    this.trigger('text', elm.value);
  }, {
    scope: this
  });

  util.tap(this.elBtn, function (e, elm) {
    if ($(this.elInput).val().trim().length <= 0) {
      $(this.elBtn).addClass('disable');
      return false;
    }
    if ($(this.elBtn).hasClass('disable')) {
      return false;
    }
    e.preventDefault();
    this.trigger('message', this.getMessage());
    this.trigger('text', '');
    this.reset();
    return false;
  }, {
    scope: this
  });

};

Input.prototype.reset = function () {
  this.elInput.value = '';
  $(this.elBtn).addClass('disable');
};

Input.prototype.getMessage = function () {
  var message = JSON.parse(JSON.stringify(this.data));
  message.val = this.elInput.value.trim();
  return message;
};

Input.prototype.getMessageFromClient = function (val) {
  var message = JSON.parse(JSON.stringify(this.data));
  message.val = val.trim();
  return message;
};

Input.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

Input.prototype.show = function () {
  this.el.style.visibility = 'visible';
  if (isIphone) {
    $(this.el).css('opacity', 0);
    $(this.elTalk).css('top', 0);
  } else {
    $(this.elTalk).css('bottom', 0);
  }
  // this.el.style.display = 'block';
  this.elInput.focus();
  this.trigger('inputshow');
};

Input.prototype.hide = function () {
  // this.el.style.display = 'none';
  this.el.style.visibility = 'hidden';
  this.elInput.blur();
  this.trigger('inputhide');
  $('.l-input').css('bottom', 0);
};

Events.mixTo(Input);

module.exports = Input;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/input/index.js